"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tencentMap = require("@/utils/tencentMap");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var DEFAULT_CENTER = {
  lng: 104.065735,
  lat: 30.659462
};
var _default2 = exports.default = {
  name: 'StoreAddressPicker',
  props: {
    region: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    storeAddress: {
      type: String,
      default: ''
    },
    longitude: {
      type: [String, Number],
      default: ''
    },
    latitude: {
      type: [String, Number],
      default: ''
    },
    areaOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      provinceId: null,
      cityId: null,
      districtId: null,
      localAddress: this.storeAddress,
      map: null,
      marker: null,
      geocoder: null,
      mapReady: false,
      syncingRegion: false,
      mapContainerId: "store-tencent-map-".concat(this._uid)
    };
  },
  computed: {
    provinceList: function provinceList() {
      return this.areaOptions || [];
    },
    cityList: function cityList() {
      var _this = this;
      var province = this.provinceList.find(function (item) {
        return item.id === _this.provinceId;
      });
      return province && province.child || [];
    },
    districtList: function districtList() {
      var _this2 = this;
      var city = this.cityList.find(function (item) {
        return item.id === _this2.cityId;
      });
      return city && city.child || [];
    },
    searchBtnDisabled: function searchBtnDisabled() {
      return this.disabled || !this.provinceId || !this.cityId || !this.districtId;
    }
  },
  watch: {
    active: function active(val) {
      var _this3 = this;
      if (val) {
        this.scheduleInitMap();
        if (this.areaOptions && this.areaOptions.length && this.storeAddress) {
          this.$nextTick(function () {
            return _this3.recognizeRegionFromAddress(_this3.storeAddress);
          });
        }
      } else {
        this.destroyMap();
      }
    },
    region: {
      immediate: true,
      handler: function handler(val) {
        this.syncRegionFromProp(val);
      }
    },
    storeAddress: function storeAddress(val) {
      var _this4 = this;
      if (val !== this.localAddress) {
        this.localAddress = val || '';
      }
      // 父组件更新 storeAddress（如编辑回显、识别裁剪回传）时尝试一次识别
      if (val && this.areaOptions && this.areaOptions.length && !this.syncingRegion) {
        this.$nextTick(function () {
          return _this4.recognizeRegionFromAddress(val);
        });
      }
    },
    areaOptions: function areaOptions(val) {
      var _this5 = this;
      this.syncRegionFromProp(this.region);
      if (val && val.length && this.storeAddress) {
        this.$nextTick(function () {
          return _this5.recognizeRegionFromAddress(_this5.storeAddress);
        });
      }
    },
    longitude: function longitude(val) {
      if (this.mapReady && val && this.latitude && !this.marker) {
        this.setMapPosition(parseFloat(this.latitude), parseFloat(val));
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyMap();
  },
  methods: {
    scheduleInitMap: function scheduleInitMap() {
      var _this6 = this;
      var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$nextTick(function () {
        setTimeout(function () {
          _this6.initMap(retry);
        }, retry === 0 ? 300 : 200);
      });
    },
    syncRegionFromProp: function syncRegionFromProp(region) {
      var _this7 = this;
      if (!Array.isArray(region)) return;
      this.syncingRegion = true;
      this.provinceId = region[0] || null;
      this.cityId = region[1] || null;
      this.districtId = region[2] || null;
      this.$nextTick(function () {
        _this7.syncingRegion = false;
      });
    },
    emitRegion: function emitRegion() {
      var region = [this.provinceId, this.cityId, this.districtId].filter(function (id) {
        return id;
      });
      this.$emit('update:region', region);
    },
    handleProvinceChange: function handleProvinceChange() {
      this.cityId = null;
      this.districtId = null;
      this.emitRegion();
    },
    handleCityChange: function handleCityChange() {
      this.districtId = null;
      this.emitRegion();
    },
    handleDistrictChange: function handleDistrictChange() {
      var _this8 = this;
      this.emitRegion();
      this.$nextTick(function () {
        return _this8.triggerFormValidate();
      });
    },
    handleAddressInput: function handleAddressInput(val) {
      this.$emit('update:storeAddress', val);
      this.recognizeRegionFromAddress(val);
    },
    /**
     * 根据输入的地址自动识别省市区，并把识别出的部分从输入框中剥离。
     * 数据格式：
     *   - areaOptions: [{ id, name: "四川省", child: [{ id, name: "成都市", child: [...] }] }]
     *   - 省名带"省"，如"四川省"；市名带"市"，如"成都市"；区名带"区"，如"武侯区"
     *
     * 支持的地址写法：
     *   四川省成都市武侯区双林路 1 号
     *   四川成都市武侯区双林路 1 号（省名可去"省"字）
     *   成都市武侯区双林路 1 号（省名可完全省略）
     */
    recognizeRegionFromAddress: function recognizeRegionFromAddress(address) {
      var _this9 = this;
      if (!address || !this.areaOptions || this.areaOptions.length === 0) return false;
      this.syncingRegion = false;
      var text = String(address).trim();
      if (!text) return false;

      // 1) 匹配省（省名带"省"字，但地址中可能写"四川省"也可能写"四川"）
      var province = null;
      var provinceLen = 0;
      var _iterator = _createForOfIteratorHelper(this.areaOptions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          if (!p || !p.name) continue;
          var pName = p.name;
          // 省名一定以"省"结尾，先取不含"省"的短名来匹配
          var pShort = pName.endsWith('省') ? pName.slice(0, -1) : pName;
          // 地址中可能写完整名"四川省"也可能写"四川"
          if (text.startsWith(pName)) {
            // 完整名匹配：如"四川省"，直接匹配
            province = p;
            provinceLen = pName.length;
            break;
          } else if (text.startsWith(pShort)) {
            // 短名匹配：如"四川"（去掉"省"），则匹配
            province = p;
            provinceLen = pShort.length;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!province) return false;

      // 消耗省名后，去除可能的"省"字残留（如输入"四川省"，已消耗"四川"，还剩"省xxx"）
      var rest = text.slice(provinceLen);
      if (rest.startsWith('省')) rest = rest.slice(1);
      rest = rest.replace(/^[\s,，.、/\\\-]+/, '');

      // 2) 匹配市（完整名匹配，名称含"市"）
      var cities = province.child || [];
      var city = null;
      var _iterator2 = _createForOfIteratorHelper(cities),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var c = _step2.value;
          if (!c || !c.name) continue;
          if (rest.startsWith(c.name)) {
            city = c;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (!city) return false;
      rest = rest.slice(city.name.length).replace(/^[\s,，.、/\\\-]+/, '');

      // 3) 匹配区（完整名匹配，名称含"区"）
      var districts = city.child || [];
      var district = null;
      var _iterator3 = _createForOfIteratorHelper(districts),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var d = _step3.value;
          if (!d || !d.name) continue;
          if (rest.startsWith(d.name)) {
            district = d;
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (!district) return false;

      // 三级都匹配上了，回填选择框并裁剪输入框
      this.syncingRegion = true;
      this.provinceId = province.id;
      this.cityId = city.id;
      this.districtId = district.id;
      var newAddress = rest.slice(district.name.length).replace(/^[\s,，.、/\\\-]+/, '');
      if (newAddress !== this.localAddress) {
        this.localAddress = newAddress;
        this.$emit('update:storeAddress', newAddress);
      }
      this.emitRegion();
      this.$nextTick(function () {
        _this9.syncingRegion = false;
        _this9.triggerFormValidate();
      });
    },
    getSelectedRegionText: function getSelectedRegionText() {
      var _this0 = this;
      var province = this.provinceList.find(function (item) {
        return item.id === _this0.provinceId;
      });
      var city = this.cityList.find(function (item) {
        return item.id === _this0.cityId;
      });
      var district = this.districtList.find(function (item) {
        return item.id === _this0.districtId;
      });
      return [province && province.name, city && city.name, district && district.name].filter(Boolean).join('');
    },
    searchAddress: function () {
      var _searchAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this1 = this;
        var keyword, regionText, maxAttempts, attempt, key, url, json, nextKey, list, first, loc, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(!this.provinceId || !this.cityId || !this.districtId)) {
                _context.n = 1;
                break;
              }
              this.$message.warning('请先选择省市区');
              return _context.a(2);
            case 1:
              if (!(!this.localAddress || !this.localAddress.trim())) {
                _context.n = 2;
                break;
              }
              this.$message.warning('请填写门店具体位置');
              return _context.a(2);
            case 2:
              if (this.mapReady) {
                _context.n = 3;
                break;
              }
              this.$message.warning('地图尚未加载完成，请稍后再试');
              return _context.a(2);
            case 3:
              keyword = this.localAddress.trim();
              regionText = this.getSelectedRegionText();
              maxAttempts = 3;
              attempt = 0;
            case 4:
              if (!(attempt < maxAttempts)) {
                _context.n = 18;
                break;
              }
              key = void 0;
              _context.p = 5;
              _context.n = 6;
              return (0, _tencentMap.getTencentMapKey)();
            case 6:
              key = _context.v;
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              this.$message.error(_t.message || '获取腾讯地图 Key 失败');
              return _context.a(2);
            case 8:
              url = "https://apis.map.qq.com/ws/place/v1/search?" + "boundary=region(".concat(encodeURIComponent(regionText), ",0)") + "&keyword=".concat(encodeURIComponent(keyword)) + "&page_size=1&page_index=1" + "&key=".concat(encodeURIComponent(key));
              _context.p = 9;
              _context.n = 10;
              return (0, _tencentMap.tencentJsonp)(url);
            case 10:
              json = _context.v;
              if (!(json.status !== 0)) {
                _context.n = 13;
                break;
              }
              if (!(json.status === 121)) {
                _context.n = 12;
                break;
              }
              // 配额超限，切换到下一个 key 重试
              nextKey = (0, _tencentMap.rotateToNextKey)();
              if (nextKey) {
                _context.n = 11;
                break;
              }
              this.$message.error("\u5730\u5740\u641C\u7D22\u5931\u8D25: ".concat(json.message || '此key每日调用量已达到上限（status=121）'));
              return _context.a(2);
            case 11:
              return _context.a(3, 17);
            case 12:
              this.$message.error("\u5730\u5740\u641C\u7D22\u5931\u8D25: ".concat(json.message || '未知错误', "\uFF08status=").concat(json.status, "\uFF09"));
              return _context.a(2);
            case 13:
              list = Array.isArray(json.data) ? json.data : [];
              if (!(list.length === 0)) {
                _context.n = 14;
                break;
              }
              this.$message.error('未找到该地址，请检查省市区和详细地址是否正确');
              return _context.a(2);
            case 14:
              first = list[0];
              loc = first && first.location;
              if (!(!loc || typeof loc.lat !== 'number' || typeof loc.lng !== 'number')) {
                _context.n = 15;
                break;
              }
              this.$message.error('未找到该地址的坐标信息，请尝试更详细的地址描述');
              return _context.a(2);
            case 15:
              this.setMapPosition(loc.lat, loc.lng);
              this.$emit('update:longitude', String(loc.lng));
              this.$emit('update:latitude', String(loc.lat));
              this.$nextTick(function () {
                return _this1.triggerFormValidate();
              });
              return _context.a(2);
            case 16:
              _context.p = 16;
              _t2 = _context.v;
              console.error('[StoreAddressPicker] WebService search failed:', _t2);
              this.$message.error('地址搜索失败：' + (_t2 && _t2.message || _t2));
              return _context.a(2);
            case 17:
              attempt++;
              _context.n = 4;
              break;
            case 18:
              // 所有 key 都耗尽，发飞书通知并报错
              this.$message.error("\u5730\u5740\u641C\u7D22\u5931\u8D25: \u817E\u8BAF\u5730\u56FE Key \u7684\u6BCF\u65E5\u8C03\u7528\u91CF\u5747\u5DF2\u8FBE\u5230\u4E0A\u9650\uFF0C\u8BF7\u5237\u65B0\u540E\u91CD\u8BD5");
              (0, _tencentMap.notifyAllKeysExhausted)();
            case 19:
              return _context.a(2);
          }
        }, _callee, this, [[9, 16], [5, 7]]);
      }));
      function searchAddress() {
        return _searchAddress.apply(this, arguments);
      }
      return searchAddress;
    }(),
    initMap: function () {
      var _initMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this10 = this;
        var retry,
          container,
          qq,
          hasCoords,
          centerLatLng,
          _args2 = arguments,
          _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              retry = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 0;
              if (this.active) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return (0, _tencentMap.loadTencentMap)();
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t3 = _context2.v;
              console.error('[StoreAddressPicker] 腾讯地图加载失败:', _t3);
              this.$message.error(_t3.message || '腾讯地图加载失败');
              return _context2.a(2);
            case 4:
              container = document.getElementById(this.mapContainerId);
              if (container) {
                _context2.n = 5;
                break;
              }
              if (retry < 5) this.scheduleInitMap(retry + 1);
              return _context2.a(2);
            case 5:
              if (!(container.offsetWidth === 0 || container.offsetHeight === 0)) {
                _context2.n = 6;
                break;
              }
              if (retry < 8) this.scheduleInitMap(retry + 1);
              return _context2.a(2);
            case 6:
              if (!this.map) {
                _context2.n = 7;
                break;
              }
              if (typeof this.map.refresh === 'function') this.map.refresh();
              return _context2.a(2);
            case 7:
              qq = window.qq.maps;
              hasCoords = this.longitude && this.latitude;
              centerLatLng = hasCoords ? new qq.LatLng(parseFloat(this.latitude), parseFloat(this.longitude)) : new qq.LatLng(DEFAULT_CENTER.lat, DEFAULT_CENTER.lng);
              this.map = new qq.Map(document.getElementById(this.mapContainerId), {
                center: centerLatLng,
                zoom: hasCoords ? 16 : 12
              });

              // 不再实例化 qq.Geocoder——反向地理编码改走 WebService API，避免 JSONP 异步 reject 导致的
              // "Cannot read properties of undefined (reading 'type')" 内部错误
              this.geocoder = null;
              if (hasCoords) {
                this.setMarker(centerLatLng);
              }
              qq.event.addListener(this.map, 'click', function (event) {
                if (_this10.disabled) return;
                _this10.handleMapClick(event.latLng);
              });
              this.mapReady = true;
              setTimeout(function () {
                if (_this10.map && typeof _this10.map.refresh === 'function') _this10.map.refresh();
              }, 200);
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function initMap() {
        return _initMap.apply(this, arguments);
      }
      return initMap;
    }(),
    handleMapClick: function handleMapClick(latLng) {
      this.setMapPosition(latLng.lat, latLng.lng);
      this.$emit('update:longitude', String(latLng.lng));
      this.$emit('update:latitude', String(latLng.lat));
      this.requestReverseGeocode(latLng.lat, latLng.lng);
    },
    requestReverseGeocode: function requestReverseGeocode(lat, lng) {
      var _this11 = this;
      var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var maxAttempts = 3;
      return (0, _tencentMap.getTencentMapKey)().then(function (key) {
        var url = "https://apis.map.qq.com/ws/geocoder/v1/?" + "location=".concat(encodeURIComponent("".concat(lat, ",").concat(lng))) + "&get_poi=0" + "&key=".concat(encodeURIComponent(key));
        return (0, _tencentMap.tencentJsonp)(url);
      }).then(function (json) {
        if (json.status !== 0 || !json.result) {
          // 配额超限则轮换 key 重试
          if (json.status === 121 && attempt < maxAttempts - 1) {
            (0, _tencentMap.rotateToNextKey)();
            return _this11.requestReverseGeocode(lat, lng, attempt + 1);
          }
          // 所有 key 都耗尽，发飞书通知
          if (json.status === 121) {
            (0, _tencentMap.notifyAllKeysExhausted)();
          }
          console.warn('[StoreAddressPicker] 逆地址解析未返回有效结果:', json);
          return;
        }
        var result = json.result || {};
        var comp = result.address_component || result.addressComponent || {};
        if (comp.province || comp.city || comp.district) {
          _this11.applyRegionByName(comp.province, comp.city, comp.district);
        }
        var detailAddress = _this11.extractDetailAddress(comp, result.address || '');
        if (detailAddress) {
          _this11.localAddress = detailAddress;
          _this11.$emit('update:storeAddress', detailAddress);
        }
        _this11.$nextTick(function () {
          return _this11.triggerFormValidate();
        });
      }).catch(function (err) {
        console.error('[StoreAddressPicker] WebService reverse geocode failed:', err);
      });
    },
    applyRegionByName: function applyRegionByName(provinceName, cityName, districtName) {
      var _this12 = this;
      var province = this.findAreaByName(this.provinceList, provinceName);
      if (!province) return;
      this.syncingRegion = true;
      this.provinceId = province.id;
      var cities = province.child || [];
      var city = this.findAreaByName(cities, cityName, provinceName);
      this.cityId = city ? city.id : null;
      var districts = city && city.child || [];
      var district = this.findAreaByName(districts, districtName, cityName);
      this.districtId = district ? district.id : null;
      this.$nextTick(function () {
        _this12.syncingRegion = false;
        _this12.emitRegion();
      });
    },
    findAreaByName: function findAreaByName(list, name, parentName) {
      var _this13 = this;
      if (!list || !list.length || !name) return null;
      var normalizedTarget = this.normalizeAreaName(name);
      var matched = list.find(function (item) {
        return _this13.normalizeAreaName(item.name) === normalizedTarget;
      });
      if (matched) return matched;
      matched = list.find(function (item) {
        return item.name === name || name.includes(item.name) || item.name.includes(name);
      });
      if (matched) return matched;
      if (parentName) {
        var parentNorm = this.normalizeAreaName(parentName);
        if (normalizedTarget === parentNorm) return list[0];
      }
      return null;
    },
    normalizeAreaName: function normalizeAreaName(name) {
      if (!name) return '';
      return name.replace(/(特别行政区|自治区|自治州|地区|盟|省|市|区|县)$/g, '').replace(/壮族|回族|维吾尔/g, '').trim();
    },
    extractDetailAddress: function extractDetailAddress(comp, fullAddress) {
      var streetPart = [comp.street, comp.streetNumber].filter(Boolean).join('');
      if (streetPart) return streetPart;
      var detail = fullAddress || '';
      [comp.province, comp.city, comp.district].forEach(function (part) {
        if (part && detail.indexOf(part) === 0) {
          detail = detail.slice(part.length);
        }
      });
      return detail.trim();
    },
    triggerFormValidate: function triggerFormValidate() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$refs && parent.$refs.storeForm) {
          parent.$refs.storeForm.validateField(['region', 'storeAddress', 'longitude']);
          break;
        }
        parent = parent.$parent;
      }
    },
    setMapPosition: function setMapPosition(lat, lng) {
      var latLng = new window.qq.maps.LatLng(lat, lng);
      this.map.panTo(latLng);
      this.setMarker(latLng);
    },
    setMarker: function setMarker(latLng) {
      if (this.marker && typeof this.marker.setMap === 'function') {
        // 腾讯 v2 通过把 marker.setMap(null) 从地图上移除
        this.marker.setMap(null);
      } else if (this.marker && this.map && typeof this.map.removeOverlay === 'function') {
        this.map.removeOverlay(this.marker);
      }
      this.marker = new window.qq.maps.Marker({
        position: latLng,
        map: this.map
      });
    },
    destroyMap: function destroyMap() {
      if (this.map) {
        this.map = null;
      }
      this.marker = null;
      this.geocoder = null;
      this.mapReady = false;
    },
    refreshMap: function refreshMap() {
      if (!this.active) return;
      if (this.map) {
        if (typeof this.map.refresh === 'function') this.map.refresh();
        return;
      }
      this.scheduleInitMap();
    }
  }
};